import React, { Component } from 'react';
import './Tweet.css';

class DistilleryTweet extends Component {
  render() {
    return (
      <div className="tweet-container">
        <div className="tweet-text">
          {this.props.text}
        </div>
        <div className="tweet-info">
          <div className="image">
            <img src={this.props.twitterImage} className="twitter-image" alt="twitter logo" />
          </div>
          by
          <div className="image">
            <img src={this.props.userImage} className="user-image" alt="twitter profile " />
          </div>
          <div className="author">{this.props.author} </div>
        </div>
      </div>
    );
  }
}

export default DistilleryTweet;



// WEBPACK FOOTER //
// ./src/components/common/Tweet.js